import { Configuration } from '../models/configuration.model';

let environmentPromise: Promise<Configuration>;

const env: string = (process.env.REACT_APP_ENV as string | undefined)?.toLowerCase() || 'development';

if (env === 'uat') {
  environmentPromise = import('./environment.uat').then(module => module.environment);
} else if (env === 'qa') {
  environmentPromise = import('./environment.qa').then(module => module.environment);
} else {
  environmentPromise = import('./environment.development').then(module => module.environment);
}

export default environmentPromise;
